// extracted by mini-css-extract-plugin
module.exports = {"talentPartnersLayout":"TalentPartnersLayout_talentPartnersLayout__2APOn","logo":"TalentPartnersLayout_logo__1DXb1","content":"TalentPartnersLayout_content__2GaF9"};